import React, { useState } from 'react'
import PropTypes from 'prop-types'

import { ButtonGroup } from 'components/ButtonGroup'

export const RatingScaleButtonGroup = ({ scale, onChange }) => {
  const SCALES = [2, 3, 4, 5]
  const [selectedScale, setSelectedScale] = useState(scale)

  // Build the click handler inline each render so it always calls the CURRENT
  // `onChange`. Memoizing per button froze each handler on first mount (the deps
  // were `[scale]` — the button's number, which never changes), so every click
  // forever invoked the first render's `onChange`. For the opinion-scale picker
  // that meant `onScaleChange` ran against the question's first-render choices —
  // on a new question those were the empty defaults, so changing the scale after
  // typing wiped the freshly typed labels (PET-1806).
  const handleSelect = (ratingScale) => {
    setSelectedScale(ratingScale)
    onChange(ratingScale)
  }

  return (
    <ButtonGroup bold>
      {SCALES.map((ratingScale) => (
        <ButtonGroup.Button
          id={`${ratingScale}-scale-btn`}
          type="button"
          key={ratingScale}
          onClick={() => handleSelect(ratingScale)}
          active={ratingScale === selectedScale}
        >
          {ratingScale}
        </ButtonGroup.Button>
      ))}
    </ButtonGroup>
  )
}

RatingScaleButtonGroup.propTypes = {
  scale: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
}

RatingScaleButtonGroup.defaultProps = {
  onChange: () => {},
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/RatingScaleButtonGroup/index.js